import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ChatContact from "./ChatContact";
import { closeContact, openContact } from "@/store/chat/contacts/Actions"; // eslint-disable-next-line fht-eslint-rules/no-restricted-syntax-enhanced

import "font-awesome/css/font-awesome.css";

var ChatContactList =
/** @class */
function (_super) {
  __extends(ChatContactList, _super);

  function ChatContactList(props) {
    var _this = _super.call(this, props) || this;

    _this.handleCloseContactTab = function (contact) {
      _this.props.store.dispatch(closeContact(contact));
    };

    _this.handleOpenContact = function (contact) {
      _this.props.store.dispatch(openContact(contact));
    };

    _this.onSearchChanged = function (e) {
      _this.setState({
        q: e.target.value
      });
    };

    _this.filterContact = function (contact) {
      if (!_this.state.q.length) return true;
      var name = contact.getContactInfo().name;
      return name.toLocaleLowerCase().includes(_this.state.q.toLocaleLowerCase());
    };

    _this.state = {
      q: ""
    };
    return _this;
  }

  ChatContactList.prototype.render = function () {
    var _this = this;

    var contactList = this.props.contacts.filter(this.filterContact).map(function (contact) {
      var klasses = "chat-contact__item " + (contact.chatId.encode() === _this.props.currentContact.chatId.encode() ? "chat-contact__item-selected" : "");
      return _jsx("li", __assign({
        className: klasses,
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();

          _this.handleOpenContact(contact);
        }
      }, {
        children: _jsx(ChatContact, {
          contact: contact,
          lastMessage: _this.props.lastMessages[contact.chatId.encode()],
          handleCloseContactTab: _this.handleCloseContactTab
        }, void 0)
      }), contact.clientId);
    });
    return _jsxs("div", __assign({
      className: "chat-contact"
    }, {
      children: [_jsx("input", {
        className: "chat-contact__search-input",
        type: "text",
        placeholder: "\uF002 \u641C\u7D22",
        onChange: this.onSearchChanged
      }, void 0), _jsx("ul", __assign({
        className: "chat-contact__list"
      }, {
        children: contactList
      }), void 0)]
    }), void 0);
  };

  return ChatContactList;
}(React.Component);

export default ChatContactList;